export default __webpack_public_path__ + "static/media/slider-img2.7ee70ae2.jpg";